<app-modal
    [isOpen]="true"
    title="Case Inquiry Details"
    size="lg"
    [showFooter]="showAdminActions || showSubmitCaseButton"
    [showCancelButton]="false"
    [showSubmitButton]="false"
    (close)="onClose()">
    @if (enquiry) {
        <div class="case-content-wrapper">
            <div class="form-section-wrapper">
                <div class="form-section-title">
                    Basic Information
                    <div class="section-description">
                        Provide the case's basic information.
                    </div>
                </div>
                <div class="form-section-content">
                    <div class="info-row">
                        <label>Status</label>
                        <div class="status-banner" [ngClass]="getStatusClass(enquiry.inquiries_status)">{{ enquiry.inquiries_status }}</div>
                    </div>
                    <div class="info-row">
                        <label>Case Inquiry ID</label>
                        <div class="value">{{ enquiry.id }}</div>
                    </div>
                    <div class="info-row">
                        <label>Case Inquiry Date</label>
                        <div class="value">{{ enquiry.incident_date | date }}</div>
                    </div>
                    <div class="info-row">
                        <label>Attorney Name</label>
                        <div class="value">John Smith</div>
                    </div>
                </div>
            </div>
            <div class="form-section-wrapper">
                <div class="form-section-title">
                    Client & Injury Details
                    <div class="section-description">
                        Client and injury related information.
                    </div>
                </div>
                <div class="form-section-content">
                    <div class="info-row">
                        <label>Client Name</label>
                        <div class="value">{{ enquiry.client_name }}</div>
                    </div>
                    <div class="info-row">
                        <label>Basic Injury Type</label>
                        <div class="value">{{ enquiry.injury_type }}</div>
                    </div>
                    <div class="info-row">
                        <label>Date of Incident</label>
                        <div class="value">{{ enquiry.incident_date | date }}</div>
                    </div>
                </div>
            </div>
            <div class="form-section-wrapper">
                <div class="form-section-title">
                    Settlement Details
                    <div class="section-description">
                        Settlement and loan information.
                    </div>
                </div>
                <div class="form-section-content">
                    <div class="info-row">
                        <label>Lien Amount ($)</label>
                        <div class="value">{{ (enquiry.lien_amount || 0) | currency }}</div>
                    </div>
                    <div class="info-row">
                        <label>Additional details of lien issue / status (Optional)</label>
                        <div class="value text-wrap">{{ enquiry.lien_details }}</div>
                    </div>
                    <div class="info-row">
                        <label>Settlement Status</label>
                        <div class="value">
                            <span [class.settled]="enquiry.settlement_status === 'SETTLED'">
                                {{ getSettlementStatusLabel(enquiry.settlement_status) }}
                            </span>
                        </div>
                    </div>
                    <div class="info-row">
                        <label>Settlement Amount ($)</label>
                        <div class="value">{{ (enquiry.settlement_amount || 0) | currency }}</div>
                    </div>
                    <div class="info-row">
                        <label>Settlement Loans</label>
                        <div class="value">{{ enquiry.has_loans ? 'Yes' : 'No' }}</div>
                    </div>
                    <div class="info-row">
                        <label>Amount of Loan ($)</label>
                        <div class="value">{{ (enquiry.loan_amount || 0) | currency }}</div>
                    </div>
                </div>
            </div>
            <div class="form-section-wrapper">
                <div class="form-section-title">
                    Financial Summary
                    <div class="section-description">
                        Medicals, legal fees, and costs.
                    </div>
                </div>
                <div class="form-section-content">
                    <div class="metric-card">
                        <label>Total Medicals INCLUDING hospital lien at issue ($)</label>
                        <div class="amount">{{ enquiry.total_medicals | currency }}</div>
                    </div>
                    <div class="metric-card">
                        <label>Legal Fees ($)</label>
                        <div class="amount">{{ enquiry.legal_fees | currency }}</div>
                    </div>
                    <div class="metric-card">
                        <label>Costs ($)</label>
                        <div class="amount">{{ enquiry.costs | currency }}</div>
                    </div>
                </div>
            </div>
        </div>
    }

    <!-- Admin: Accept / Reject actions (only when status is New) -->
    @if (showAdminActions) {
        <div footer class="enquiry-admin-actions">
            <button class="btn btn-md btn-danger" [disabled]="isSubmitting" (click)="rejectEnquiry()">
                Reject
            </button>
            <button class="btn btn-md btn-primary" [disabled]="isSubmitting" (click)="acceptEnquiry()">
                Accept
            </button>
        </div>
    }

    <!-- Attorney: Submit Case Details (only when accepted) -->
    @if (showSubmitCaseButton) {
        <div footer class="modal-footer-content">
            <button class="btn btn-primary btn-md btn-full-width" (click)="submitCaseDetail()">
                Submit Case Details
            </button>
        </div>
    }
</app-modal>
